<template>
    <div class="user-login-form">

        <b-form @submit.stop.prevent="onSubmit">

            <b-form-group horizontal
                          label-cols="4"
                          :label="$i18n.gt('FIELD_LOGIN_EMAIL')"
                          :invalid-feedback="invalidFeedback('email')">
                <b-form-input type="text"
                              Autocapitalize="off"
                              v-model="$v.email.$model"
                              :state="state('email')">
                </b-form-input>
            </b-form-group>
            <b-form-group horizontal
                          label-cols="4"
                          :label="$i18n.gt('FIELD_LOGIN_PASSWORD')"
                          :invalid-feedback="invalidFeedback('password')">
                <b-form-input type="password"
                              v-model="$v.password.$model"
                              :state="state('password')">
                </b-form-input>
            </b-form-group>

            <b-button class="float-right"
                      type="submit"
                      variant="primary"
                      :disabled="$v.email.$invalid || $v.password.$invalid">
                {{ $i18n.gt('LABEL_LOGIN') }}
            </b-button>

        </b-form>

        <div style="clear:both"></div>

        <b-alert show variant="danger" class="mt-3"
                 v-if="loginError">
            {{ $i18n.gt('LABEL_INCORRECT_LOGIN') }}
        </b-alert>

    </div>

</template>

<script>

    import Vue from 'vue'

    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'

    export default Vue.extend({
        name: "UserLoginForm",
        mixins: [validationMixin],
        props: {
            requestedPath: String
        },
        data() {
            return {
                email: '',
                password: '',
                loginError: false
            }
        },
        validations: {
            email: {
                required
            },
            password: {
                required
            }
        },
        methods: {
            state(fieldName) {
                const f = this.$v[fieldName]
                if (f) {
                    return f.$dirty ? !f.$error : null
                } else {
                    return null
                }
            },
            invalidFeedback(fieldName) {
                return ''
            },
            onSubmit(evt) {
                this.$v.$touch()
                if (this.$v.email.$error || this.$v.password.$error) {
                    return
                } else {
                    this.$user.loginUser(this, this.email, this.password)
                        .then((response) => {
                                if (this.requestedPath) {
                                    // redirect to requested path if we forced re-login after unauthorized request
                                    this.$router.push(this.requestedPath)
                                } else {
                                    this.$router.push('/')
                                }
                            },
                            (response) => { // error
                                this.loginError = true
                            })
                }
            }
        }

    })
</script>
